import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  createChecklist,
  deleteChecklistById,
  getAllCheckLists,
} from '../helpers/checklist-api';
import errorHandling from '../helpers/error-handling';
import { sortByAlphapeticalOrder } from '../helpers/helpers';
import useAuth from '../hooks/useAuth';

/*
  Components
*/
import SnackBar from '../components/SnackBar';
import Loader from '../components/Loader';

const Home = () => {
  const { token } = useAuth();
  const history = useHistory();
  const [checklists, setChecklists] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [newListTitle, setNewListTitle] = useState<string>('');

  useEffect(() => {
    getAllCheckLists(token)
      .then(errorHandling)
      .then((data: any) => {
        setChecklists(sortByAlphapeticalOrder(data));
      })
      .catch(() => setError(true))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    localStorage.checklists = JSON.stringify(checklists);
  }, [checklists]);

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    const newCheckList = {
      checklistTitle: newListTitle,
      tasks: [],
      states: {
        notDone: {
          id: 'notDone',
          title: 'to do',
          taskIds: [],
        },
        done: {
          id: 'done',
          title: 'done',
          taskIds: [],
        },
      },
    };
    createChecklist(newCheckList, token)
      .then(response => response.json())
      .then(data => {
        setChecklists([...checklists, data]);
        setNewListTitle('');
      })
      .catch(() => setError(true));
  };

  const handleBtnClick = (e: any, id: string) => {
    if (e.target.name === 'deleteBtn') {
      deleteChecklistById(id, token)
        .then(() => {
          setChecklists(checklists.filter((checklist: any) => checklist._id !== id));
        })
        .catch(() => setError(true));
    } else {
      // console.log(id);
      history.push(`/checklists/${id}`);
    }
  };

  /* eslint-disable */
  return (
    <>
      <section className="content__container checklists">
        <form className="background-container" onSubmit={handleFormSubmit}>
          <h1 className="form__title">Add new List</h1>
          <input
            className="form__input"
            type="text"
            placeholder="Enter list name"
            value={newListTitle}
            onChange={e => setNewListTitle(e.target.value.toLowerCase())} />
          <button className="form__btn" type="submit">Add List</button>
        </form>
        {error && <SnackBar state={error} setState={setError} type="error" message="There has been an error. Please try again" />}
        {isLoading && <Loader />}
        {!isLoading && (
          <ul className="background-container checklist">
            {checklists.length === 0 && <p>Try adding your first checklist</p>}
            {checklists.length > 0 && checklists.map((checklist: any) => (
              <li onClick={e => handleBtnClick(e, checklist._id)} className="checklist__btn" key={checklist._id}>
                <h2>{checklist.checklistTitle}</h2>
                <button type="button" name="deleteBtn" className="checklist__delete">Delete</button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </>
  );
};

export default Home;
